import React from 'react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuSeparator,
  DropdownMenuItem,
} from './dropdown-menu';

const MultiSelectDropdown = ({ label, icon: Icon, options, selected, onChange }) => {
  const allSelected = selected.length === options.length;
  const noneSelected = selected.length === 0;

  const toggle = (value) => {
    onChange(
      selected.includes(value)
        ? selected.filter((v) => v !== value)
        : [...selected, value]
    );
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-1.5 h-8 px-3 text-xs font-medium rounded-md border border-border bg-card text-muted-foreground hover:text-foreground hover:border-foreground/20 transition-colors"
        >
          {Icon && <Icon className="h-3.5 w-3.5" />}
          {label}
          {selected.length > 0 && (
            <span className="ml-1 px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-primary/20 text-primary">
              {selected.length}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[180px]">
        <div className="flex items-center gap-1 px-2 py-1">
          <button
            type="button"
            onClick={() => onChange(options.map((o) => o.value))}
            disabled={allSelected}
            className="text-[10px] text-muted-foreground hover:text-foreground disabled:opacity-30 transition-colors"
          >
            All
          </button>
          <span className="text-muted-foreground/40 text-[10px]">/</span>
          <button
            type="button"
            onClick={() => onChange([])}
            disabled={noneSelected}
            className="text-[10px] text-muted-foreground hover:text-foreground disabled:opacity-30 transition-colors"
          >
            None
          </button>
        </div>
        <DropdownMenuSeparator />
        {options.map((opt) => (
          <DropdownMenuCheckboxItem
            key={opt.value}
            checked={selected.includes(opt.value)}
            onCheckedChange={() => toggle(opt.value)}
            onSelect={(e) => e.preventDefault()}
          >
            {opt.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MultiSelectDropdown;
